export * from './Paper.types';
export * from './components';
export * from './hoc';
export { default as PaperContainer } from './Paper.container';
export { default as PaperRenderer } from './Paper.renderer';
export default {
  render: () => {},
};
